import { render, staticRenderFns } from "./FeaturedMovies.vue?vue&type=template&id=142550ac&scoped=true&"
import script from "./FeaturedMovies.vue?vue&type=script&lang=js&"
export * from "./FeaturedMovies.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedMovies.vue?vue&type=style&index=0&id=142550ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142550ac",
  null
  
)

component.options.__file = "FeaturedMovies.vue"
export default component.exports